var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', {
    key: _vm.form.links.length,
    staticClass: "ma-n4",
    attrs: {
      "multiple": "",
      "column": ""
    }
  }, [_vm._l(_vm.form.links, function (item, i) {
    return [_c('links-popup', {
      key: i,
      on: {
        "input": _vm.emit
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var attrs = _ref.attrs,
            on = _ref.on;
          return [_c('v-chip', _vm._g(_vm._b({
            staticClass: "ma-4",
            attrs: {
              "outlined": "",
              "large": "",
              "label": "",
              "close": ""
            },
            on: {
              "click:close": function ($event) {
                return _vm.pull(item);
              }
            }
          }, 'v-chip', attrs, false), on), [_c('span', [_vm._v(_vm._s(item.name))])])];
        }
      }], null, true),
      model: {
        value: _vm.form.links[i],
        callback: function ($$v) {
          _vm.$set(_vm.form.links, i, $$v);
        },
        expression: "form.links[i]"
      }
    })];
  }), _c('links-popup', {
    attrs: {
      "isCreate": ""
    },
    on: {
      "input": _vm.push
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-4 pa-0",
          attrs: {
            "tag": "v-chip",
            "outlined": "",
            "large": "",
            "label": "",
            "width": "32",
            "min-width": "32",
            "height": "32"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
      }
    }])
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }